var map = {
	"./OfficinaSans-Book.otf": 17781,
	"./audiofiles/1-1.mp3": 74191,
	"./audiofiles/1-10.mp3": 7133,
	"./audiofiles/1-11.mp3": 31384,
	"./audiofiles/1-12.mp3": 47631,
	"./audiofiles/1-13.mp3": 69130,
	"./audiofiles/1-14.mp3": 93849,
	"./audiofiles/1-15.mp3": 87028,
	"./audiofiles/1-16.mp3": 38699,
	"./audiofiles/1-17.mp3": 77926,
	"./audiofiles/1-18.mp3": 51669,
	"./audiofiles/1-19.mp3": 70928,
	"./audiofiles/1-2.mp3": 97144,
	"./audiofiles/1-20.mp3": 97952,
	"./audiofiles/1-3.mp3": 9661,
	"./audiofiles/1-4.mp3": 62662,
	"./audiofiles/1-5.mp3": 71147,
	"./audiofiles/1-6.mp3": 66708,
	"./audiofiles/1-7.mp3": 22553,
	"./audiofiles/1-8.mp3": 47490,
	"./audiofiles/1-9.mp3": 52423,
	"./audiofiles/10-1.mp3": 24201,
	"./audiofiles/10-10.mp3": 72427,
	"./audiofiles/10-11.mp3": 16966,
	"./audiofiles/10-12.mp3": 34329,
	"./audiofiles/10-13.mp3": 9108,
	"./audiofiles/10-14.mp3": 85967,
	"./audiofiles/10-15.mp3": 60330,
	"./audiofiles/10-2.mp3": 77814,
	"./audiofiles/10-3.mp3": 45531,
	"./audiofiles/10-4.mp3": 61736,
	"./audiofiles/10-5.mp3": 7021,
	"./audiofiles/10-6.mp3": 45498,
	"./audiofiles/10-7.mp3": 54463,
	"./audiofiles/10-8.mp3": 55004,
	"./audiofiles/10-9.mp3": 90305,
	"./audiofiles/11-1.mp3": 92632,
	"./audiofiles/11-10.mp3": 76672,
	"./audiofiles/11-2.mp3": 92527,
	"./audiofiles/11-3.mp3": 14026,
	"./audiofiles/11-4.mp3": 38745,
	"./audiofiles/11-5.mp3": 48276,
	"./audiofiles/11-6.mp3": 83595,
	"./audiofiles/11-7.mp3": 39174,
	"./audiofiles/11-8.mp3": 96565,
	"./audiofiles/11-9.mp3": 15824,
	"./audiofiles/12-1.mp3": 94007,
	"./audiofiles/12-10.mp3": 42389,
	"./audiofiles/12-2.mp3": 38816,
	"./audiofiles/12-3.mp3": 14533,
	"./audiofiles/12-4.mp3": 25006,
	"./audiofiles/12-5.mp3": 23251,
	"./audiofiles/12-6.mp3": 62876,
	"./audiofiles/12-7.mp3": 39297,
	"./audiofiles/12-8.mp3": 83994,
	"./audiofiles/12-9.mp3": 92959,
	"./audiofiles/13-1.mp3": 96526,
	"./audiofiles/13-10.mp3": 258,
	"./audiofiles/13-11.mp3": 5191,
	"./audiofiles/13-12.mp3": 50256,
	"./audiofiles/13-13.mp3": 36885,
	"./audiofiles/13-14.mp3": 37630,
	"./audiofiles/13-15.mp3": 6019,
	"./audiofiles/13-2.mp3": 27169,
	"./audiofiles/13-3.mp3": 34396,
	"./audiofiles/13-4.mp3": 65527,
	"./audiofiles/13-5.mp3": 18482,
	"./audiofiles/13-6.mp3": 86053,
	"./audiofiles/13-7.mp3": 26688,
	"./audiofiles/13-8.mp3": 13019,
	"./audiofiles/13-9.mp3": 87830,
	"./audiofiles/14-1.mp3": 45133,
	"./audiofiles/14-10.mp3": 73847,
	"./audiofiles/14-2.mp3": 56762,
	"./audiofiles/14-3.mp3": 65727,
	"./audiofiles/14-4.mp3": 69892,
	"./audiofiles/14-5.mp3": 88489,
	"./audiofiles/14-6.mp3": 89078,
	"./audiofiles/14-7.mp3": 14267,
	"./audiofiles/14-8.mp3": 27936,
	"./audiofiles/14-9.mp3": 87301,
	"./audiofiles/15-1.mp3": 1436,
	"./audiofiles/15-10.mp3": 24812,
	"./audiofiles/15-2.mp3": 82771,
	"./audiofiles/15-3.mp3": 72270,
	"./audiofiles/15-4.mp3": 55909,
	"./audiofiles/15-5.mp3": 5632,
	"./audiofiles/15-6.mp3": 69879,
	"./audiofiles/15-7.mp3": 49010,
	"./audiofiles/15-8.mp3": 93609,
	"./audiofiles/15-9.mp3": 79620,
	"./audiofiles/16-1.mp3": 27835,
	"./audiofiles/16-10.mp3": 91745,
	"./audiofiles/16-11.mp3": 15324,
	"./audiofiles/16-12.mp3": 75699,
	"./audiofiles/16-13.mp3": 77454,
	"./audiofiles/16-14.mp3": 66981,
	"./audiofiles/16-15.mp3": 91264,
	"./audiofiles/16-16.mp3": 46455,
	"./audiofiles/16-17.mp3": 99410,
	"./audiofiles/16-18.mp3": 68169,
	"./audiofiles/16-19.mp3": 33220,
	"./audiofiles/16-2.mp3": 80868,
	"./audiofiles/16-20.mp3": 22244,
	"./audiofiles/16-3.mp3": 94857,
	"./audiofiles/16-4.mp3": 9530,
	"./audiofiles/16-5.mp3": 36767,
	"./audiofiles/16-6.mp3": 69448,
	"./audiofiles/16-7.mp3": 43053,
	"./audiofiles/16-8.mp3": 73518,
	"./audiofiles/16-9.mp3": 84019,
	"./audiofiles/17-1.mp3": 38130,
	"./audiofiles/17-2.mp3": 28677,
	"./audiofiles/18-1.mp3": 95009,
	"./audiofiles/18-2.mp3": 69070,
	"./audiofiles/19-1.mp3": 6800,
	"./audiofiles/19-10.mp3": 69224,
	"./audiofiles/19-11.mp3": 14509,
	"./audiofiles/19-12.mp3": 52986,
	"./audiofiles/19-13.mp3": 61951,
	"./audiofiles/19-14.mp3": 96740,
	"./audiofiles/19-15.mp3": 31689,
	"./audiofiles/19-2.mp3": 61735,
	"./audiofiles/19-3.mp3": 56802,
	"./audiofiles/19-4.mp3": 66609,
	"./audiofiles/19-5.mp3": 8748,
	"./audiofiles/19-6.mp3": 62563,
	"./audiofiles/19-7.mp3": 94174,
	"./audiofiles/19-8.mp3": 2621,
	"./audiofiles/19-9.mp3": 90104,
	"./audiofiles/2-1.mp3": 96240,
	"./audiofiles/2-2.mp3": 51175,
	"./audiofiles/20-1.mp3": 22116,
	"./audiofiles/20-10.mp3": 24580,
	"./audiofiles/20-11.mp3": 59529,
	"./audiofiles/20-12.mp3": 60118,
	"./audiofiles/20-13.mp3": 85307,
	"./audiofiles/20-14.mp3": 1512,
	"./audiofiles/20-15.mp3": 16173,
	"./audiofiles/20-2.mp3": 26555,
	"./audiofiles/20-3.mp3": 33526,
	"./audiofiles/20-4.mp3": 94797,
	"./audiofiles/20-5.mp3": 63720,
	"./audiofiles/20-6.mp3": 4863,
	"./audiofiles/20-7.mp3": 91898,
	"./audiofiles/20-8.mp3": 40705,
	"./audiofiles/20-9.mp3": 13308,
	"./audiofiles/21-1.mp3": 97621,
	"./audiofiles/21-10.mp3": 14223,
	"./audiofiles/21-11.mp3": 40170,
	"./audiofiles/21-12.mp3": 78173,
	"./audiofiles/21-13.mp3": 55448,
	"./audiofiles/21-14.mp3": 5291,
	"./audiofiles/21-15.mp3": 48966,
	"./audiofiles/21-2.mp3": 60994,
	"./audiofiles/21-3.mp3": 65927,
	"./audiofiles/21-4.mp3": 12940,
	"./audiofiles/21-5.mp3": 70801,
	"./audiofiles/21-6.mp3": 98366,
	"./audiofiles/21-7.mp3": 83107,
	"./audiofiles/21-8.mp3": 94296,
	"./audiofiles/21-9.mp3": 6813,
	"./audiofiles/22-1.mp3": 86202,
	"./audiofiles/22-10.mp3": 53990,
	"./audiofiles/22-2.mp3": 89101,
	"./audiofiles/22-3.mp3": 58024,
	"./audiofiles/22-4.mp3": 20859,
	"./audiofiles/22-5.mp3": 11478,
	"./audiofiles/22-6.mp3": 83433,
	"./audiofiles/22-7.mp3": 16420,
	"./audiofiles/22-8.mp3": 90327,
	"./audiofiles/22-9.mp3": 43282,
	"./audiofiles/23-1.mp3": 53091,
	"./audiofiles/23-10.mp3": 51609,
	"./audiofiles/23-2.mp3": 29900,
	"./audiofiles/23-3.mp3": 61585,
	"./audiofiles/23-4.mp3": 4802,
	"./audiofiles/23-5.mp3": 9735,
	"./audiofiles/23-6.mp3": 54800,
	"./audiofiles/23-7.mp3": 14581,
	"./audiofiles/23-8.mp3": 46150,
	"./audiofiles/23-9.mp3": 1611,
	"./audiofiles/24-1.mp3": 75328,
	"./audiofiles/24-10.mp3": 61560,
	"./audiofiles/24-2.mp3": 82103,
	"./audiofiles/24-3.mp3": 35058,
	"./audiofiles/24-4.mp3": 26785,
	"./audiofiles/24-5.mp3": 83036,
	"./audiofiles/24-6.mp3": 64371,
	"./audiofiles/24-7.mp3": 41966,
	"./audiofiles/24-8.mp3": 80877,
	"./audiofiles/24-9.mp3": 49800,
	"./audiofiles/25-1.mp3": 38641,
	"./audiofiles/25-10.mp3": 4227,
	"./audiofiles/25-11.mp3": 23934,
	"./audiofiles/25-12.mp3": 96369,
	"./audiofiles/25-13.mp3": 81036,
	"./audiofiles/25-14.mp3": 44519,
	"./audiofiles/25-15.mp3": 39586,
	"./audiofiles/25-2.mp3": 46654,
	"./audiofiles/25-3.mp3": 38595,
	"./audiofiles/25-4.mp3": 56720,
	"./audiofiles/25-5.mp3": 37461,
	"./audiofiles/25-6.mp3": 92930,
	"./audiofiles/25-7.mp3": 86791,
	"./audiofiles/25-8.mp3": 89172,
	"./audiofiles/25-9.mp3": 79641,
	"./audiofiles/26-1.mp3": 92374,
	"./audiofiles/26-10.mp3": 35354,
	"./audiofiles/26-2.mp3": 64329,
	"./audiofiles/26-3.mp3": 80964,
	"./audiofiles/26-4.mp3": 63711,
	"./audiofiles/26-5.mp3": 50746,
	"./audiofiles/26-6.mp3": 69997,
	"./audiofiles/26-7.mp3": 22568,
	"./audiofiles/26-8.mp3": 37139,
	"./audiofiles/26-9.mp3": 31086,
	"./audiofiles/27-1.mp3": 67999,
	"./audiofiles/27-10.mp3": 64685,
	"./audiofiles/27-2.mp3": 84328,
	"./audiofiles/27-3.mp3": 74285,
	"./audiofiles/27-4.mp3": 96662,
	"./audiofiles/27-5.mp3": 59067,
	"./audiofiles/27-6.mp3": 12100,
	"./audiofiles/27-7.mp3": 26089,
	"./audiofiles/27-8.mp3": 81490,
	"./audiofiles/27-9.mp3": 8388,
	"./audiofiles/28-1.mp3": 12812,
	"./audiofiles/28-10.mp3": 28284,
	"./audiofiles/28-2.mp3": 17603,
	"./audiofiles/28-3.mp3": 25662,
	"./audiofiles/28-4.mp3": 85845,
	"./audiofiles/28-5.mp3": 5104,
	"./audiofiles/28-6.mp3": 23271,
	"./audiofiles/28-7.mp3": 41314,
	"./audiofiles/28-8.mp3": 28025,
	"./audiofiles/28-9.mp3": 68180,
	"./audiofiles/29-1.mp3": 89469,
	"./audiofiles/29-10.mp3": 39015,
	"./audiofiles/29-2.mp3": 14090,
	"./audiofiles/29-3.mp3": 39727,
	"./audiofiles/29-4.mp3": 62868,
	"./audiofiles/29-5.mp3": 88089,
	"./audiofiles/29-6.mp3": 54374,
	"./audiofiles/29-7.mp3": 9835,
	"./audiofiles/29-8.mp3": 63024,
	"./audiofiles/29-9.mp3": 22805,
	"./audiofiles/3-1.mp3": 801,
	"./audiofiles/3-10.mp3": 57107,
	"./audiofiles/3-2.mp3": 74862,
	"./audiofiles/3-3.mp3": 85363,
	"./audiofiles/3-4.mp3": 91872,
	"./audiofiles/3-5.mp3": 58501,
	"./audiofiles/3-6.mp3": 51602,
	"./audiofiles/3-7.mp3": 56119,
	"./audiofiles/3-8.mp3": 82212,
	"./audiofiles/3-9.mp3": 96201,
	"./audiofiles/30-1.mp3": 19471,
	"./audiofiles/30-10.mp3": 29437,
	"./audiofiles/30-11.mp3": 16920,
	"./audiofiles/30-12.mp3": 93967,
	"./audiofiles/30-13.mp3": 84682,
	"./audiofiles/30-14.mp3": 58681,
	"./audiofiles/30-15.mp3": 86484,
	"./audiofiles/30-2.mp3": 77048,
	"./audiofiles/30-3.mp3": 83421,
	"./audiofiles/30-4.mp3": 54214,
	"./audiofiles/30-5.mp3": 10539,
	"./audiofiles/30-6.mp3": 5844,
	"./audiofiles/30-7.mp3": 65689,
	"./audiofiles/30-8.mp3": 78978,
	"./audiofiles/30-9.mp3": 60935,
	"./audiofiles/31-1.mp3": 25734,
	"./audiofiles/31-10.mp3": 10890,
	"./audiofiles/31-2.mp3": 53561,
	"./audiofiles/31-3.mp3": 77364,
	"./audiofiles/31-4.mp3": 90991,
	"./audiofiles/31-5.mp3": 16938,
	"./audiofiles/31-6.mp3": 54941,
	"./audiofiles/31-7.mp3": 48568,
	"./audiofiles/31-8.mp3": 26787,
	"./audiofiles/31-9.mp3": 34846,
	"./audiofiles/32-1.mp3": 49281,
	"./audiofiles/32-10.mp3": 97331,
	"./audiofiles/32-11.mp3": 74926,
	"./audiofiles/32-12.mp3": 43393,
	"./audiofiles/32-13.mp3": 15996,
	"./audiofiles/32-14.mp3": 15063,
	"./audiofiles/32-15.mp3": 68018,
	"./audiofiles/32-2.mp3": 61838,
	"./audiofiles/32-3.mp3": 43731,
	"./audiofiles/32-4.mp3": 48800,
	"./audiofiles/32-5.mp3": 93893,
	"./audiofiles/32-6.mp3": 26322,
	"./audiofiles/32-7.mp3": 3991,
	"./audiofiles/32-8.mp3": 48228,
	"./audiofiles/32-9.mp3": 83177,
	"./audiofiles/33-1.mp3": 41520,
	"./audiofiles/33-10.mp3": 59432,
	"./audiofiles/33-11.mp3": 6861,
	"./audiofiles/33-12.mp3": 3962,
	"./audiofiles/33-13.mp3": 575,
	"./audiofiles/33-14.mp3": 17828,
	"./audiofiles/33-15.mp3": 1193,
	"./audiofiles/33-2.mp3": 59687,
	"./audiofiles/33-3.mp3": 77730,
	"./audiofiles/33-4.mp3": 11537,
	"./audiofiles/33-5.mp3": 49228,
	"./audiofiles/33-6.mp3": 54019,
	"./audiofiles/33-7.mp3": 62078,
	"./audiofiles/33-8.mp3": 82173,
	"./audiofiles/33-9.mp3": 75800,
	"./audiofiles/34-1.mp3": 4531,
	"./audiofiles/34-10.mp3": 74921,
	"./audiofiles/34-11.mp3": 60932,
	"./audiofiles/34-12.mp3": 7899,
	"./audiofiles/34-13.mp3": 45494,
	"./audiofiles/34-14.mp3": 23117,
	"./audiofiles/34-15.mp3": 33160,
	"./audiofiles/34-2.mp3": 23196,
	"./audiofiles/34-3.mp3": 50593,
	"./audiofiles/34-4.mp3": 58866,
	"./audiofiles/34-5.mp3": 5911,
	"./audiofiles/34-6.mp3": 15488,
	"./audiofiles/34-7.mp3": 65765,
	"./audiofiles/34-8.mp3": 43414,
	"./audiofiles/34-9.mp3": 36443,
	"./audiofiles/35-1.mp3": 97578,
	"./audiofiles/35-10.mp3": 14454,
	"./audiofiles/35-2.mp3": 35581,
	"./audiofiles/35-3.mp3": 59832,
	"./audiofiles/35-4.mp3": 50795,
	"./audiofiles/35-5.mp3": 6374,
	"./audiofiles/35-6.mp3": 22297,
	"./audiofiles/35-7.mp3": 15476,
	"./audiofiles/35-8.mp3": 13095,
	"./audiofiles/35-9.mp3": 35586,
	"./audiofiles/36-1.mp3": 24613,
	"./audiofiles/36-10.mp3": 7071,
	"./audiofiles/36-11.mp3": 98106,
	"./audiofiles/36-12.mp3": 59629,
	"./audiofiles/36-13.mp3": 14344,
	"./audiofiles/36-14.mp3": 20520,
	"./audiofiles/36-15.mp3": 30422,
	"./audiofiles/36-2.mp3": 17714,
	"./audiofiles/36-3.mp3": 64759,
	"./audiofiles/36-4.mp3": 82044,
	"./audiofiles/36-5.mp3": 9441,
	"./audiofiles/36-6.mp3": 40974,
	"./audiofiles/36-7.mp3": 63379,
	"./audiofiles/36-8.mp3": 32456,
	"./audiofiles/36-9.mp3": 79885,
	"./audiofiles/37-1.mp3": 42708,
	"./audiofiles/37-10.mp3": 84948,
	"./audiofiles/37-2.mp3": 78027,
	"./audiofiles/37-3.mp3": 33606,
	"./audiofiles/37-4.mp3": 62813,
	"./audiofiles/37-5.mp3": 87064,
	"./audiofiles/37-6.mp3": 86959,
	"./audiofiles/37-7.mp3": 24810,
	"./audiofiles/37-8.mp3": 92177,
	"./audiofiles/37-9.mp3": 17964,
	"./audiofiles/38-1.mp3": 44023,
	"./audiofiles/38-10.mp3": 87989,
	"./audiofiles/38-2.mp3": 79776,
	"./audiofiles/38-3.mp3": 30053,
	"./audiofiles/38-4.mp3": 46414,
	"./audiofiles/38-5.mp3": 73267,
	"./audiofiles/38-6.mp3": 91932,
	"./audiofiles/38-7.mp3": 88705,
	"./audiofiles/38-8.mp3": 82426,
	"./audiofiles/38-9.mp3": 26015,
	"./audiofiles/39-1.mp3": 39470,
	"./audiofiles/39-2.mp3": 81761,
	"./audiofiles/4-1.mp3": 79722,
	"./audiofiles/4-10.mp3": 28406,
	"./audiofiles/4-2.mp3": 71453,
	"./audiofiles/4-3.mp3": 1464,
	"./audiofiles/4-4.mp3": 75467,
	"./audiofiles/4-5.mp3": 36358,
	"./audiofiles/4-6.mp3": 53721,
	"./audiofiles/4-7.mp3": 28500,
	"./audiofiles/4-8.mp3": 83591,
	"./audiofiles/4-9.mp3": 78658,
	"./audiofiles/40-1.mp3": 29642,
	"./audiofiles/40-10.mp3": 91606,
	"./audiofiles/40-11.mp3": 987,
	"./audiofiles/40-12.mp3": 96548,
	"./audiofiles/40-13.mp3": 63561,
	"./audiofiles/40-14.mp3": 66330,
	"./audiofiles/40-15.mp3": 79295,
	"./audiofiles/40-2.mp3": 67645,
	"./audiofiles/40-3.mp3": 91896,
	"./audiofiles/40-4.mp3": 82859,
	"./audiofiles/40-5.mp3": 38438,
	"./audiofiles/40-6.mp3": 54361,
	"./audiofiles/40-7.mp3": 47540,
	"./audiofiles/40-8.mp3": 45159,
	"./audiofiles/40-9.mp3": 67650,
	"./audiofiles/41-1.mp3": 20243,
	"./audiofiles/41-10.mp3": 52073,
	"./audiofiles/41-11.mp3": 38084,
	"./audiofiles/41-12.mp3": 1403,
	"./audiofiles/41-13.mp3": 22646,
	"./audiofiles/41-14.mp3": 269,
	"./audiofiles/41-15.mp3": 26664,
	"./audiofiles/41-2.mp3": 55260,
	"./audiofiles/41-3.mp3": 82657,
	"./audiofiles/41-4.mp3": 90930,
	"./audiofiles/41-5.mp3": 37975,
	"./audiofiles/41-6.mp3": 31200,
	"./audiofiles/41-7.mp3": 97829,
	"./audiofiles/41-8.mp3": 75478,
	"./audiofiles/41-9.mp3": 68507,
	"./audiofiles/42-1.mp3": 74772,
	"./audiofiles/42-10.mp3": 62100,
	"./audiofiles/42-2.mp3": 10091,
	"./audiofiles/42-3.mp3": 65670,
	"./audiofiles/42-4.mp3": 94877,
	"./audiofiles/42-5.mp3": 19128,
	"./audiofiles/42-6.mp3": 19023,
	"./audiofiles/42-7.mp3": 34493,
	"./audiofiles/42-8.mp3": 24241,
	"./audiofiles/42-9.mp3": 50028,
	"./audiofiles/43-1.mp3": 56677,
	"./audiofiles/43-10.mp3": 84223,
	"./audiofiles/43-2.mp3": 49778,
	"./audiofiles/43-3.mp3": 96823,
	"./audiofiles/43-4.mp3": 14108,
	"./audiofiles/43-5.mp3": 41505,
	"./audiofiles/43-6.mp3": 73038,
	"./audiofiles/43-7.mp3": 79091,
	"./audiofiles/43-8.mp3": 64520,
	"./audiofiles/43-9.mp3": 11949,
	"./audiofiles/44-1.mp3": 57798,
	"./audiofiles/5-1.mp3": 1427,
	"./audiofiles/5-10.mp3": 80393,
	"./audiofiles/5-2.mp3": 88028,
	"./audiofiles/5-3.mp3": 6977,
	"./audiofiles/5-4.mp3": 84018,
	"./audiofiles/5-5.mp3": 61687,
	"./audiofiles/5-6.mp3": 6496,
	"./audiofiles/5-7.mp3": 51589,
	"./audiofiles/5-8.mp3": 94486,
	"./audiofiles/5-9.mp3": 62203,
	"./audiofiles/6-1.mp3": 34196,
	"./audiofiles/6-10.mp3": 28020,
	"./audiofiles/6-2.mp3": 81163,
	"./audiofiles/6-3.mp3": 42054,
	"./audiofiles/6-4.mp3": 77149,
	"./audiofiles/6-5.mp3": 7160,
	"./audiofiles/6-6.mp3": 11055,
	"./audiofiles/6-7.mp3": 85418,
	"./audiofiles/6-8.mp3": 41137,
	"./audiofiles/6-9.mp3": 25804,
	"./audiofiles/7-1.mp3": 10437,
	"./audiofiles/7-10.mp3": 99807,
	"./audiofiles/7-11.mp3": 56218,
	"./audiofiles/7-12.mp3": 89741,
	"./audiofiles/7-13.mp3": 16136,
	"./audiofiles/7-14.mp3": 90875,
	"./audiofiles/7-15.mp3": 12118,
	"./audiofiles/7-2.mp3": 42866,
	"./audiofiles/7-3.mp3": 20535,
	"./audiofiles/7-4.mp3": 46876,
	"./audiofiles/7-5.mp3": 65825,
	"./audiofiles/7-6.mp3": 56001,
	"./audiofiles/7-7.mp3": 60275,
	"./audiofiles/7-8.mp3": 37256,
	"./audiofiles/7-9.mp3": 82541,
	"./audiofiles/8-1.mp3": 2318,
	"./audiofiles/8-10.mp3": 70306,
	"./audiofiles/8-2.mp3": 16609,
	"./audiofiles/8-3.mp3": 23836,
	"./audiofiles/8-4.mp3": 71319,
	"./audiofiles/8-5.mp3": 24274,
	"./audiofiles/8-6.mp3": 91845,
	"./audiofiles/8-7.mp3": 16128,
	"./audiofiles/8-8.mp3": 18811,
	"./audiofiles/8-9.mp3": 93622,
	"./audiofiles/9-1.mp3": 99799,
	"./audiofiles/9-10.mp3": 12437,
	"./audiofiles/9-2.mp3": 44608,
	"./audiofiles/9-3.mp3": 20325,
	"./audiofiles/9-4.mp3": 30798,
	"./audiofiles/9-5.mp3": 12691,
	"./audiofiles/9-6.mp3": 52316,
	"./audiofiles/9-7.mp3": 45089,
	"./audiofiles/9-8.mp3": 89786,
	"./audiofiles/9-9.mp3": 82399,
	"./audiofiles/audioAdjustment.mp3": 64567,
	"./audiofiles/sample_Triangel.mp3": 34543,
	"./audiofilesPlus/1-1.mp3": 95387,
	"./audiofilesPlus/1-2.mp3": 39108,
	"./audiofilesPlus/1-3.mp3": 74057,
	"./audiofilesPlus/1-4.mp3": 11706,
	"./audiofilesPlus/1-5.mp3": 4319,
	"./audiofilesPlus/1-6.mp3": 11592,
	"./audiofilesPlus/10-1.mp3": 58765,
	"./audiofilesPlus/10-2.mp3": 97242,
	"./audiofilesPlus/10-3.mp3": 6207,
	"./audiofilesPlus/10-4.mp3": 40996,
	"./audiofilesPlus/10-5.mp3": 59593,
	"./audiofilesPlus/10-6.mp3": 29558,
	"./audiofilesPlus/11-1.mp3": 84444,
	"./audiofilesPlus/11-10.mp3": 29740,
	"./audiofilesPlus/11-11.mp3": 61425,
	"./audiofilesPlus/11-12.mp3": 88990,
	"./audiofilesPlus/11-13.mp3": 52931,
	"./audiofilesPlus/11-14.mp3": 54640,
	"./audiofilesPlus/11-15.mp3": 14421,
	"./audiofilesPlus/11-2.mp3": 65779,
	"./audiofilesPlus/11-3.mp3": 43374,
	"./audiofilesPlus/11-4.mp3": 27013,
	"./audiofilesPlus/11-5.mp3": 76736,
	"./audiofilesPlus/11-6.mp3": 83511,
	"./audiofilesPlus/11-7.mp3": 36466,
	"./audiofilesPlus/11-8.mp3": 76617,
	"./audiofilesPlus/11-9.mp3": 93252,
	"./audiofilesPlus/12-1.mp3": 15291,
	"./audiofilesPlus/12-10.mp3": 96673,
	"./audiofilesPlus/12-2.mp3": 94500,
	"./audiofilesPlus/12-3.mp3": 77865,
	"./audiofilesPlus/12-4.mp3": 80634,
	"./audiofilesPlus/12-5.mp3": 77247,
	"./audiofilesPlus/12-6.mp3": 36104,
	"./audiofilesPlus/12-7.mp3": 83533,
	"./audiofilesPlus/12-8.mp3": 44622,
	"./audiofilesPlus/12-9.mp3": 67027,
	"./audiofilesPlus/13-1.mp3": 9234,
	"./audiofilesPlus/13-2.mp3": 99781,
	"./audiofilesPlus/13-3.mp3": 49504,
	"./audiofilesPlus/13-4.mp3": 38547,
	"./audiofilesPlus/13-5.mp3": 16142,
	"./audiofilesPlus/13-6.mp3": 84609,
	"./audiofilesPlus/14-1.mp3": 90857,
	"./audiofilesPlus/14-10.mp3": 4203,
	"./audiofilesPlus/14-2.mp3": 91446,
	"./audiofilesPlus/14-3.mp3": 16635,
	"./audiofilesPlus/14-4.mp3": 32840,
	"./audiofilesPlus/14-5.mp3": 47501,
	"./audiofilesPlus/14-6.mp3": 59130,
	"./audiofilesPlus/14-7.mp3": 68095,
	"./audiofilesPlus/14-8.mp3": 38012,
	"./audiofilesPlus/14-9.mp3": 30785,
	"./audiofilesPlus/15-1.mp3": 16760,
	"./audiofilesPlus/15-10.mp3": 8448,
	"./audiofilesPlus/15-2.mp3": 75535,
	"./audiofilesPlus/15-3.mp3": 1482,
	"./audiofilesPlus/15-4.mp3": 21753,
	"./audiofilesPlus/15-5.mp3": 61908,
	"./audiofilesPlus/15-6.mp3": 66603,
	"./audiofilesPlus/15-7.mp3": 87897,
	"./audiofilesPlus/15-8.mp3": 79573,
	"./audiofilesPlus/15-9.mp3": 98832,
	"./audiofilesPlus/16-1.mp3": 7639,
	"./audiofilesPlus/16-10.mp3": 16693,
	"./audiofilesPlus/16-11.mp3": 35952,
	"./audiofilesPlus/16-12.mp3": 37767,
	"./audiofilesPlus/16-13.mp3": 72162,
	"./audiofilesPlus/16-14.mp3": 89617,
	"./audiofilesPlus/16-15.mp3": 43660,
	"./audiofilesPlus/16-2.mp3": 52448,
	"./audiofilesPlus/16-3.mp3": 97541,
	"./audiofilesPlus/16-4.mp3": 65486,
	"./audiofilesPlus/16-5.mp3": 63731,
	"./audiofilesPlus/16-6.mp3": 33980,
	"./audiofilesPlus/16-7.mp3": 52929,
	"./audiofilesPlus/16-8.mp3": 24474,
	"./audiofilesPlus/16-9.mp3": 33439,
	"./audiofilesPlus/17-1.mp3": 37006,
	"./audiofilesPlus/17-10.mp3": 15682,
	"./audiofilesPlus/17-2.mp3": 63182,
	"./audiofilesPlus/17-3.mp3": 5500,
	"./audiofilesPlus/17-4.mp3": 79159,
	"./audiofilesPlus/17-5.mp3": 1490,
	"./audiofilesPlus/17-6.mp3": 69061,
	"./audiofilesPlus/17-7.mp3": 40320,
	"./audiofilesPlus/17-8.mp3": 96027,
	"./audiofilesPlus/17-9.mp3": 28310,
	"./audiofilesPlus/18-1.mp3": 75749,
	"./audiofilesPlus/18-10.mp3": 45183,
	"./audiofilesPlus/18-11.mp3": 48570,
	"./audiofilesPlus/18-2.mp3": 8178,
	"./audiofilesPlus/18-3.mp3": 55223,
	"./audiofilesPlus/18-4.mp3": 24092,
	"./audiofilesPlus/18-5.mp3": 513,
	"./audiofilesPlus/18-6.mp3": 86222,
	"./audiofilesPlus/18-7.mp3": 84467,
	"./audiofilesPlus/18-8.mp3": 18920,
	"./audiofilesPlus/18-9.mp3": 33581,
	"./audiofilesPlus/19-1.mp3": 11412,
	"./audiofilesPlus/19-10.mp3": 73396,
	"./audiofilesPlus/19-11.mp3": 80217,
	"./audiofilesPlus/19-12.mp3": 64294,
	"./audiofilesPlus/19-13.mp3": 8715,
	"./audiofilesPlus/19-14.mp3": 17752,
	"./audiofilesPlus/19-15.mp3": 93501,
	"./audiofilesPlus/19-2.mp3": 32203,
	"./audiofilesPlus/19-3.mp3": 7366,
	"./audiofilesPlus/19-4.mp3": 54365,
	"./audiofilesPlus/19-5.mp3": 41848,
	"./audiofilesPlus/19-6.mp3": 18895,
	"./audiofilesPlus/19-7.mp3": 9610,
	"./audiofilesPlus/19-8.mp3": 18353,
	"./audiofilesPlus/19-9.mp3": 60492,
	"./audiofilesPlus/2-1.mp3": 3612,
	"./audiofilesPlus/2-2.mp3": 33363,
	"./audiofilesPlus/2-3.mp3": 35118,
	"./audiofilesPlus/20-1.mp3": 17640,
	"./audiofilesPlus/20-10.mp3": 73872,
	"./audiofilesPlus/20-2.mp3": 10367,
	"./audiofilesPlus/20-3.mp3": 1402,
	"./audiofilesPlus/20-4.mp3": 80105,
	"./audiofilesPlus/20-5.mp3": 45156,
	"./audiofilesPlus/20-6.mp3": 1435,
	"./audiofilesPlus/20-7.mp3": 33718,
	"./audiofilesPlus/20-8.mp3": 74469,
	"./audiofilesPlus/20-9.mp3": 45728,
	"./audiofilesPlus/21-1.mp3": 87801,
	"./audiofilesPlus/21-10.mp3": 11067,
	"./audiofilesPlus/21-2.mp3": 11558,
	"./audiofilesPlus/21-3.mp3": 36395,
	"./audiofilesPlus/21-4.mp3": 46040,
	"./audiofilesPlus/21-5.mp3": 58557,
	"./audiofilesPlus/21-6.mp3": 13802,
	"./audiofilesPlus/21-7.mp3": 39439,
	"./audiofilesPlus/21-8.mp3": 64684,
	"./audiofilesPlus/21-9.mp3": 22545,
	"./audiofilesPlus/22-1.mp3": 17598,
	"./audiofilesPlus/22-10.mp3": 15602,
	"./audiofilesPlus/22-2.mp3": 90033,
	"./audiofilesPlus/22-3.mp3": 74700,
	"./audiofilesPlus/22-4.mp3": 38183,
	"./audiofilesPlus/22-5.mp3": 33250,
	"./audiofilesPlus/22-6.mp3": 59381,
	"./audiofilesPlus/22-7.mp3": 99600,
	"./audiofilesPlus/22-8.mp3": 46411,
	"./audiofilesPlus/22-9.mp3": 90950,
	"./audiofilesPlus/23-1.mp3": 58823,
	"./audiofilesPlus/23-10.mp3": 99397,
	"./audiofilesPlus/23-2.mp3": 3888,
	"./audiofilesPlus/23-3.mp3": 90517,
	"./audiofilesPlus/23-4.mp3": 91262,
	"./audiofilesPlus/23-5.mp3": 59651,
	"./audiofilesPlus/23-6.mp3": 5836,
	"./audiofilesPlus/23-7.mp3": 63697,
	"./audiofilesPlus/23-8.mp3": 54954,
	"./audiofilesPlus/23-9.mp3": 80591,
	"./audiofilesPlus/24-1.mp3": 83916,
	"./audiofilesPlus/24-10.mp3": 86236,
	"./audiofilesPlus/24-2.mp3": 58083,
	"./audiofilesPlus/24-3.mp3": 66142,
	"./audiofilesPlus/24-4.mp3": 56949,
	"./audiofilesPlus/24-5.mp3": 76208,
	"./audiofilesPlus/24-6.mp3": 6279,
	"./audiofilesPlus/24-7.mp3": 28770,
	"./audiofilesPlus/24-8.mp3": 99129,
	"./audiofilesPlus/24-9.mp3": 8660,
	"./audiofilesPlus/25-1.mp3": 72477,
	"./audiofilesPlus/25-2.mp3": 27722,
	"./audiofilesPlus/25-3.mp3": 53359,
	"./audiofilesPlus/25-4.mp3": 29524,
	"./audiofilesPlus/25-5.mp3": 1721,
	"./audiofilesPlus/26-1.mp3": 6722,
	"./audiofilesPlus/26-10.mp3": 93854,
	"./audiofilesPlus/26-11.mp3": 85795,
	"./audiofilesPlus/26-12.mp3": 81004,
	"./audiofilesPlus/26-13.mp3": 43313,
	"./audiofilesPlus/26-14.mp3": 9506,
	"./audiofilesPlus/26-15.mp3": 91463,
	"./audiofilesPlus/26-2.mp3": 51253,
	"./audiofilesPlus/26-3.mp3": 70512,
	"./audiofilesPlus/26-4.mp3": 52387,
	"./audiofilesPlus/26-5.mp3": 60446,
	"./audiofilesPlus/26-6.mp3": 36081,
	"./audiofilesPlus/26-7.mp3": 78220,
	"./audiofilesPlus/26-8.mp3": 47215,
	"./audiofilesPlus/26-9.mp3": 68714,
	"./audiofilesPlus/27-1.mp3": 11947,
	"./audiofilesPlus/27-10.mp3": 16785,
	"./audiofilesPlus/27-11.mp3": 1452,
	"./audiofilesPlus/27-12.mp3": 24643,
	"./audiofilesPlus/27-2.mp3": 7252,
	"./audiofilesPlus/27-3.mp3": 67097,
	"./audiofilesPlus/27-4.mp3": 46826,
	"./audiofilesPlus/27-5.mp3": 20879,
	"./audiofilesPlus/27-6.mp3": 62104,
	"./audiofilesPlus/27-7.mp3": 84829,
	"./audiofilesPlus/27-8.mp3": 64734,
	"./audiofilesPlus/27-9.mp3": 56675,
	"./audiofilesPlus/28-1.mp3": 58336,
	"./audiofilesPlus/28-10.mp3": 66488,
	"./audiofilesPlus/28-2.mp3": 22583,
	"./audiofilesPlus/28-3.mp3": 18066,
	"./audiofilesPlus/28-4.mp3": 50913,
	"./audiofilesPlus/28-5.mp3": 70492,
	"./audiofilesPlus/28-6.mp3": 35475,
	"./audiofilesPlus/28-7.mp3": 24974,
	"./audiofilesPlus/28-8.mp3": 94509,
	"./audiofilesPlus/28-9.mp3": 20904,
	"./audiofilesPlus/29-1.mp3": 9745,
	"./audiofilesPlus/29-10.mp3": 66627,
	"./audiofilesPlus/29-11.mp3": 98238,
	"./audiofilesPlus/29-12.mp3": 70673,
	"./audiofilesPlus/29-13.mp3": 90431,
	"./audiofilesPlus/29-14.mp3": 49447,
	"./audiofilesPlus/29-15.mp3": 44514,
	"./audiofilesPlus/29-2.mp3": 60286,
	"./audiofilesPlus/29-3.mp3": 52227,
	"./audiofilesPlus/29-4.mp3": 39728,
	"./audiofilesPlus/29-5.mp3": 20469,
	"./audiofilesPlus/29-6.mp3": 75938,
	"./audiofilesPlus/29-7.mp3": 57895,
	"./audiofilesPlus/29-8.mp3": 2804,
	"./audiofilesPlus/29-9.mp3": 62649,
	"./audiofilesPlus/3-1.mp3": 96685,
	"./audiofilesPlus/3-10.mp3": 22391,
	"./audiofilesPlus/3-2.mp3": 63162,
	"./audiofilesPlus/3-3.mp3": 6751,
	"./audiofilesPlus/3-4.mp3": 50852,
	"./audiofilesPlus/3-5.mp3": 64841,
	"./audiofilesPlus/3-6.mp3": 19062,
	"./audiofilesPlus/3-7.mp3": 97819,
	"./audiofilesPlus/3-8.mp3": 60512,
	"./audiofilesPlus/3-9.mp3": 10789,
	"./audiofilesPlus/30-1.mp3": 75635,
	"./audiofilesPlus/30-2.mp3": 94300,
	"./audiofilesPlus/30-3.mp3": 91073,
	"./audiofilesPlus/30-4.mp3": 41874,
	"./audiofilesPlus/30-5.mp3": 46391,
	"./audiofilesPlus/31-1.mp3": 68682,
	"./audiofilesPlus/31-10.mp3": 19382,
	"./audiofilesPlus/31-2.mp3": 6685,
	"./audiofilesPlus/31-3.mp3": 312,
	"./audiofilesPlus/31-4.mp3": 33803,
	"./audiofilesPlus/31-5.mp3": 77478,
	"./audiofilesPlus/31-6.mp3": 88953,
	"./audiofilesPlus/31-7.mp3": 29108,
	"./audiofilesPlus/31-8.mp3": 84199,
	"./audiofilesPlus/31-9.mp3": 2242,
	"./audiofilesPlus/32-1.mp3": 91269,
	"./audiofilesPlus/33-1.mp3": 56340,
	"./audiofilesPlus/33-2.mp3": 61035,
	"./audiofilesPlus/33-3.mp3": 4710,
	"./audiofilesPlus/33_bsp.mp3": 94844,
	"./audiofilesPlus/34-1.mp3": 90575,
	"./audiofilesPlus/34-2.mp3": 90680,
	"./audiofilesPlus/34-3.mp3": 66429,
	"./audiofilesPlus/34_bsp.mp3": 90919,
	"./audiofilesPlus/35-1.mp3": 8742,
	"./audiofilesPlus/36-1.mp3": 89761,
	"./audiofilesPlus/36-10.mp3": 59731,
	"./audiofilesPlus/36-11.mp3": 49230,
	"./audiofilesPlus/36-12.mp3": 75169,
	"./audiofilesPlus/36-13.mp3": 78396,
	"./audiofilesPlus/36-14.mp3": 30487,
	"./audiofilesPlus/36-15.mp3": 25970,
	"./audiofilesPlus/36-2.mp3": 75470,
	"./audiofilesPlus/36-3.mp3": 57363,
	"./audiofilesPlus/36-4.mp3": 89280,
	"./audiofilesPlus/36-5.mp3": 64997,
	"./audiofilesPlus/36-6.mp3": 97426,
	"./audiofilesPlus/36-7.mp3": 44471,
	"./audiofilesPlus/36-8.mp3": 31236,
	"./audiofilesPlus/36-9.mp3": 66185,
	"./audiofilesPlus/37-1.mp3": 12624,
	"./audiofilesPlus/37-2.mp3": 42695,
	"./audiofilesPlus/38-1.mp3": 80059,
	"./audiofilesPlus/38-10.mp3": 63809,
	"./audiofilesPlus/38-2.mp3": 35684,
	"./audiofilesPlus/38-3.mp3": 70633,
	"./audiofilesPlus/38-4.mp3": 38906,
	"./audiofilesPlus/38-5.mp3": 31519,
	"./audiofilesPlus/38-6.mp3": 96264,
	"./audiofilesPlus/38-7.mp3": 10925,
	"./audiofilesPlus/38-8.mp3": 79918,
	"./audiofilesPlus/38-9.mp3": 61811,
	"./audiofilesPlus/39-1.mp3": 94930,
	"./audiofilesPlus/39-10.mp3": 47214,
	"./audiofilesPlus/39-2.mp3": 62501,
	"./audiofilesPlus/39-3.mp3": 86784,
	"./audiofilesPlus/39-4.mp3": 54867,
	"./audiofilesPlus/39-5.mp3": 56622,
	"./audiofilesPlus/39-6.mp3": 87265,
	"./audiofilesPlus/39-7.mp3": 94492,
	"./audiofilesPlus/39-8.mp3": 24575,
	"./audiofilesPlus/39-9.mp3": 31962,
	"./audiofilesPlus/4-2.mp3": 51841,
	"./audiofilesPlus/40-1.mp3": 86998,
	"./audiofilesPlus/5-1.mp3": 30455,
	"./audiofilesPlus/5-10.mp3": 2485,
	"./audiofilesPlus/5-2.mp3": 66208,
	"./audiofilesPlus/5-3.mp3": 16485,
	"./audiofilesPlus/5-4.mp3": 32846,
	"./audiofilesPlus/5-5.mp3": 59699,
	"./audiofilesPlus/5-6.mp3": 78364,
	"./audiofilesPlus/5-7.mp3": 75137,
	"./audiofilesPlus/5-8.mp3": 68858,
	"./audiofilesPlus/5-9.mp3": 12447,
	"./audiofilesPlus/6-1.mp3": 34264,
	"./audiofilesPlus/6-10.mp3": 73632,
	"./audiofilesPlus/6-2.mp3": 27663,
	"./audiofilesPlus/6-3.mp3": 2026,
	"./audiofilesPlus/6-4.mp3": 76025,
	"./audiofilesPlus/6-5.mp3": 3828,
	"./audiofilesPlus/6-6.mp3": 24619,
	"./audiofilesPlus/6-7.mp3": 16134,
	"./audiofilesPlus/6-8.mp3": 37589,
	"./audiofilesPlus/6-9.mp3": 50960,
	"./audiofilesPlus/7-1.mp3": 79753,
	"./audiofilesPlus/7-10.mp3": 52075,
	"./audiofilesPlus/7-2.mp3": 7798,
	"./audiofilesPlus/7-3.mp3": 17179,
	"./audiofilesPlus/7-4.mp3": 54344,
	"./audiofilesPlus/7-5.mp3": 85421,
	"./audiofilesPlus/7-6.mp3": 82522,
	"./audiofilesPlus/7-7.mp3": 95487,
	"./audiofilesPlus/7-8.mp3": 87580,
	"./audiofilesPlus/7-9.mp3": 31329,
	"./audiofilesPlus/8-1.mp3": 84010,
	"./audiofilesPlus/8-10.mp3": 28950,
	"./audiofilesPlus/8-2.mp3": 22013,
	"./audiofilesPlus/8-3.mp3": 46264,
	"./audiofilesPlus/8-4.mp3": 37227,
	"./audiofilesPlus/8-5.mp3": 92806,
	"./audiofilesPlus/8-6.mp3": 8729,
	"./audiofilesPlus/8-7.mp3": 1908,
	"./audiofilesPlus/8-8.mp3": 99527,
	"./audiofilesPlus/8-9.mp3": 22018,
	"./audiofilesPlus/9-1.mp3": 74611,
	"./audiofilesPlus/9-10.mp3": 89417,
	"./audiofilesPlus/9-11.mp3": 75428,
	"./audiofilesPlus/9-12.mp3": 22395,
	"./audiofilesPlus/9-13.mp3": 59990,
	"./audiofilesPlus/9-14.mp3": 37613,
	"./audiofilesPlus/9-15.mp3": 47656,
	"./audiofilesPlus/9-2.mp3": 9628,
	"./audiofilesPlus/9-3.mp3": 37025,
	"./audiofilesPlus/9-4.mp3": 45298,
	"./audiofilesPlus/9-5.mp3": 92343,
	"./audiofilesPlus/9-6.mp3": 85568,
	"./audiofilesPlus/9-7.mp3": 52197,
	"./audiofilesPlus/9-8.mp3": 29846,
	"./audiofilesPlus/9-9.mp3": 22875,
	"./audiofilesPlus/audioAdjustment.mp3": 61547,
	"./audiofilesPlus/c2.mp3": 50699,
	"./audiofilesPlus/optional/1-1.mp3": 78010,
	"./audiofilesPlus/optional/1-10.mp3": 36742,
	"./audiofilesPlus/optional/1-2.mp3": 50029,
	"./audiofilesPlus/optional/1-3.mp3": 51720,
	"./audiofilesPlus/optional/1-4.mp3": 35515,
	"./audiofilesPlus/optional/1-5.mp3": 10326,
	"./audiofilesPlus/optional/1-6.mp3": 9737,
	"./audiofilesPlus/optional/1-7.mp3": 74788,
	"./audiofilesPlus/optional/1-8.mp3": 88023,
	"./audiofilesPlus/optional/1-9.mp3": 40978,
	"./audiofilesPlus/optional/2-1.mp3": 54805,
	"./audiofilesPlus/optional/2-10.mp3": 5807,
	"./audiofilesPlus/optional/2-2.mp3": 10274,
	"./audiofilesPlus/optional/2-3.mp3": 75879,
	"./audiofilesPlus/optional/2-4.mp3": 81772,
	"./audiofilesPlus/optional/2-5.mp3": 44081,
	"./audiofilesPlus/optional/2-6.mp3": 94622,
	"./audiofilesPlus/optional/2-7.mp3": 70211,
	"./audiofilesPlus/optional/2-8.mp3": 91992,
	"./audiofilesPlus/optional/2-9.mp3": 14717,
	"./audiofilesPlus/optional/3-2.mp3": 62747,
	"./audiofilesPlus/optional/4-1.mp3": 87839,
	"./audiofilesPlus/optional/4-10.mp3": 29901,
	"./audiofilesPlus/optional/4-2.mp3": 95112,
	"./audiofilesPlus/optional/4-3.mp3": 40397,
	"./audiofilesPlus/optional/4-4.mp3": 27542,
	"./audiofilesPlus/optional/4-5.mp3": 78907,
	"./audiofilesPlus/optional/4-6.mp3": 38980,
	"./audiofilesPlus/optional/4-7.mp3": 57577,
	"./audiofilesPlus/optional/4-8.mp3": 722,
	"./audiofilesPlus/optional/4-9.mp3": 78391,
	"./audiofilesPlus/optional/5-1.mp3": 96406,
	"./audiofilesPlus/optional/5-10.mp3": 29530,
	"./audiofilesPlus/optional/5-2.mp3": 95817,
	"./audiofilesPlus/optional/5-3.mp3": 60868,
	"./audiofilesPlus/optional/5-4.mp3": 73055,
	"./audiofilesPlus/optional/5-5.mp3": 64090,
	"./audiofilesPlus/optional/5-6.mp3": 36109,
	"./audiofilesPlus/optional/5-7.mp3": 37800,
	"./audiofilesPlus/optional/5-8.mp3": 3347,
	"./audiofilesPlus/optional/5-9.mp3": 5102,
	"./audiofilesPlus/optional/6-2.mp3": 21150,
	"./audiofilesPlus/optional/7-2.mp3": 79799,
	"./audiofilesPlus/optional/8-1.mp3": 95531,
	"./audiofilesPlus/optional/8-2.mp3": 91092,
	"./audiofilesPlus/optional/8-3.mp3": 46937,
	"./audiofilesPlus/optional/8-4.mp3": 72938,
	"./audiofilesPlus/optional/8-5.mp3": 98575,
	"./audiofilesPlus/optional/8_bsp.mp3": 15747,
	"./audiofilesPlus/optional/9-1.mp3": 67586,
	"./audiofilesPlus/optional/9-2.mp3": 93717,
	"./audiofilesPlus/optional/9-3.mp3": 17584,
	"./audiofilesPlus/optional/9-4.mp3": 32227,
	"./audiofilesPlus/optional/9-5.mp3": 51934,
	"./audiofilesPlus/optional/9_bsp.mp3": 18390,
	"./audiofilesPlus/optional/g_bsp.mp3": 50136,
	"./fonts/ITC-OfficinaSansITCPro-Book.eot": 91371,
	"./fonts/ITC-OfficinaSansITCPro-Book.otf": 40166,
	"./fonts/ITC-OfficinaSansITCPro-Book.svg": 8573,
	"./fonts/ITC-OfficinaSansITCPro-Book.ttf": 58749,
	"./fonts/ITC-OfficinaSansITCPro-Book.woff": 24403,
	"./fonts/ITC-OfficinaSansITCPro-Book.woff2": 67307,
	"./fonts/OfficinaSansITCPro-Bold.eot": 4283,
	"./fonts/OfficinaSansITCPro-Bold.otf": 86217,
	"./fonts/OfficinaSansITCPro-Bold.svg": 32134,
	"./fonts/OfficinaSansITCPro-Bold.ttf": 74738,
	"./fonts/OfficinaSansITCPro-Bold.woff": 73570,
	"./fonts/OfficinaSansITCPro-Bold.woff2": 34596,
	"./icons/aboutUs.svg": 68790,
	"./icons/angry.svg": 97326,
	"./icons/arrow-left.svg": 65648,
	"./icons/arrow-right.svg": 76415,
	"./icons/arrow-up.svg": 46688,
	"./icons/bird.svg": 27266,
	"./icons/cross.svg": 9973,
	"./icons/dataProtection.svg": 96130,
	"./icons/exclamation.svg": 89222,
	"./icons/exercises.svg": 16628,
	"./icons/externalTest.svg": 53138,
	"./icons/hearingLoss.svg": 84296,
	"./icons/impressum.svg": 72556,
	"./icons/menu.svg": 72434,
	"./icons/negativ/PA-Icon-Baby-neg.png": 39657,
	"./icons/negativ/PA-Icon-Baby-neg.svg": 84371,
	"./icons/negativ/PA-Icon-Fahrrad-neg_1.png": 39961,
	"./icons/negativ/PA-Icon-Fahrrad-neg_1.svg": 53853,
	"./icons/negativ/PA-Icon-Kirche-neg.png": 86509,
	"./icons/negativ/PA-Icon-Kirche-neg.svg": 78427,
	"./icons/negativ/PA-Icon-Spielplatz-neg.png": 49157,
	"./icons/negativ/PA-Icon-Spielplatz-neg.svg": 23323,
	"./icons/negativ/PA-Icon-Staubsauger-neg.png": 55277,
	"./icons/negativ/PA-Icon-Staubsauger-neg.svg": 48709,
	"./icons/negativ/PA-Icon-Stra├Яenbahn-neg.png": 76944,
	"./icons/negativ/PA-Icon-Stra├Яenbahn-neg.svg": 5569,
	"./icons/negativ/PA-Icon-Telefon-neg.png": 53918,
	"./icons/negativ/PA-Icon-Telefon-neg.svg": 24494,
	"./icons/negativ/PA-Icon-T├╝r-neg.png": 56592,
	"./icons/negativ/PA-Icon-T├╝r-neg.svg": 72542,
	"./icons/negativ/PA-Icon-Vogel-neg.png": 51440,
	"./icons/negativ/PA-Icon-Vogel-neg.svg": 86376,
	"./icons/negativ/PA-Icon-Wasserhahn-neg.png": 18373,
	"./icons/negativ/PA-Icon-Wasserhahn-neg.svg": 24579,
	"./icons/negativ/baby.png": 59446,
	"./icons/negativ/bikeBell.png": 6362,
	"./icons/negativ/birdSinging.png": 31872,
	"./icons/negativ/childrenPlayground.png": 72856,
	"./icons/negativ/dog.png": 59298,
	"./icons/negativ/doorClosing.png": 7461,
	"./icons/negativ/handMixer.png": 17986,
	"./icons/negativ/hoover.png": 71275,
	"./icons/negativ/organ.png": 55855,
	"./icons/negativ/phone.png": 32528,
	"./icons/negativ/phoneRing.png": 92270,
	"./icons/negativ/policeSiren.png": 47869,
	"./icons/negativ/stationSpeaker.png": 37481,
	"./icons/negativ/tapWater.png": 70474,
	"./icons/negativ/vaccum.png": 97457,
	"./icons/negativ/waterDrops.png": 24919,
	"./icons/ourProducts.svg": 21855,
	"./icons/pause.svg": 51947,
	"./icons/play.svg": 10757,
	"./icons/positiv/PA-Icon-Baby-pos.png": 17929,
	"./icons/positiv/PA-Icon-Baby-pos.svg": 45787,
	"./icons/positiv/PA-Icon-Baby-pos@2x.png": 75531,
	"./icons/positiv/PA-Icon-Fahrrad-neg.png": 85285,
	"./icons/positiv/PA-Icon-Fahrrad-neg.svg": 34001,
	"./icons/positiv/PA-Icon-Fahrrad-neg@2x.png": 3951,
	"./icons/positiv/PA-Icon-Kirche-pos.png": 18901,
	"./icons/positiv/PA-Icon-Kirche-pos.svg": 94979,
	"./icons/positiv/PA-Icon-Kirche-pos@2x.png": 51839,
	"./icons/positiv/PA-Icon-Spielplatz-pos.png": 88645,
	"./icons/positiv/PA-Icon-Spielplatz-pos.svg": 81635,
	"./icons/positiv/PA-Icon-Spielplatz-pos@2x.png": 783,
	"./icons/positiv/PA-Icon-Staubsauger-pos.png": 36653,
	"./icons/positiv/PA-Icon-Staubsauger-pos.svg": 64245,
	"./icons/positiv/PA-Icon-Staubsauger-pos@2x.png": 5335,
	"./icons/positiv/PA-Icon-Stra├Яenbahn-pos.png": 57676,
	"./icons/positiv/PA-Icon-Stra├Яenbahn-pos.svg": 56138,
	"./icons/positiv/PA-Icon-Stra├Яenbahn-pos@2x.png": 16700,
	"./icons/positiv/PA-Icon-Telefon-pos.png": 85650,
	"./icons/positiv/PA-Icon-Telefon-pos.svg": 41034,
	"./icons/positiv/PA-Icon-Telefon-pos@2x.png": 98914,
	"./icons/positiv/PA-Icon-T├╝r-pos.png": 59988,
	"./icons/positiv/PA-Icon-T├╝r-pos.svg": 38938,
	"./icons/positiv/PA-Icon-T├╝r-pos@2x.png": 28580,
	"./icons/positiv/PA-Icon-Vogel-pos.png": 95583,
	"./icons/positiv/PA-Icon-Vogel-pos.svg": 19188,
	"./icons/positiv/PA-Icon-Vogel-pos@2x.png": 40495,
	"./icons/positiv/PA-Icon-Wasserhahn-pos.png": 64781,
	"./icons/positiv/PA-Icon-Wasserhahn-pos.svg": 15435,
	"./icons/positiv/PA-Icon-Wasserhahn-pos@2x.png": 18967,
	"./icons/professionalInfo.svg": 36202,
	"./icons/professionalSearch.svg": 57242,
	"./icons/question.svg": 64515,
	"./icons/sad.svg": 26817,
	"./icons/settings.svg": 20716,
	"./icons/smile.svg": 21273,
	"./icons/text_size.svg": 13898,
	"./icons/triangle.svg": 11907,
	"./images/Board_1@2x.png": 45905,
	"./images/Board_2@2x.png": 53236,
	"./images/Board_3@2x.png": 77239,
	"./images/Board_4@2x.png": 45986,
	"./images/Board_5@2x.png": 51077,
	"./images/Board_6@2x.png": 16296,
	"./images/Board_7@2x.png": 91051,
	"./images/HdO.jpeg": 83501,
	"./images/Oval-border.svg": 8166,
	"./images/Oval-filled.svg": 13284,
	"./images/aboutUs1.jpg": 37979,
	"./images/aboutUs2.jpg": 95180,
	"./images/aboutUs3.jpg": 56905,
	"./images/aboutUs4.jpg": 55066,
	"./images/audio.svg": 25143,
	"./images/banana/left/N1.png": 73672,
	"./images/banana/left/N2.png": 35651,
	"./images/banana/left/N3.png": 45818,
	"./images/banana/left/N4.png": 97877,
	"./images/banana/left/N5.png": 86252,
	"./images/banana/left/N6.png": 53287,
	"./images/banana/left/N7.png": 77502,
	"./images/banana/left/S1.png": 86555,
	"./images/banana/left/S2.png": 8224,
	"./images/banana/left/S3.png": 86345,
	"./images/banana/left/ohne.png": 25365,
	"./images/banana/right/N1.png": 99387,
	"./images/banana/right/N2.png": 37408,
	"./images/banana/right/N3.png": 92233,
	"./images/banana/right/N4.png": 92406,
	"./images/banana/right/N5.png": 88735,
	"./images/banana/right/N6.png": 34084,
	"./images/banana/right/N7.png": 74029,
	"./images/banana/right/S1.png": 36808,
	"./images/banana/right/S2.png": 73667,
	"./images/banana/right/S3.png": 25914,
	"./images/banana/right/ohne.png": 42114,
	"./images/demo_results_1.png": 64753,
	"./images/demo_results_2.png": 88506,
	"./images/demo_results_3.png": 94691,
	"./images/ear.svg": 56293,
	"./images/exercisePlus/1-1-1.png": 22701,
	"./images/exercisePlus/1-1-2.png": 90934,
	"./images/exercisePlus/1-1-3.png": 44735,
	"./images/exercisePlus/1-1-4.png": 16704,
	"./images/exercisePlus/1-2-1.png": 63486,
	"./images/exercisePlus/1-2-2.png": 30837,
	"./images/exercisePlus/1-2-3.png": 61740,
	"./images/exercisePlus/1-2-4.png": 91907,
	"./images/exercisePlus/1-3-1.png": 56371,
	"./images/exercisePlus/1-3-2.png": 81880,
	"./images/exercisePlus/1-3-3.png": 54593,
	"./images/exercisePlus/1-3-4.png": 71502,
	"./images/exercisePlus/1-4-1.png": 23628,
	"./images/exercisePlus/1-4-2.png": 26279,
	"./images/exercisePlus/1-4-3.png": 73790,
	"./images/exercisePlus/1-4-4.png": 56881,
	"./images/exercisePlus/1-5-1.png": 91177,
	"./images/exercisePlus/1-5-2.png": 60210,
	"./images/exercisePlus/1-5-3.png": 75035,
	"./images/exercisePlus/1-5-4.png": 11172,
	"./images/exercisePlus/1-6-1.png": 54714,
	"./images/exercisePlus/1-6-2.png": 30961,
	"./images/exercisePlus/1-6-3.png": 82568,
	"./images/exercisePlus/1-6-4.png": 62183,
	"./images/exercisePlus/23-1.png": 62493,
	"./images/exercisePlus/23-2.png": 64934,
	"./images/exercisePlus/23-3.png": 46479,
	"./images/finish-exercise.svg": 62461,
	"./images/flag-blue.gif": 87947,
	"./images/flag-green.gif": 50332,
	"./images/home.svg": 64278,
	"./images/idO.jpeg": 38766,
	"./images/login.svg": 81514,
	"./images/logo.svg": 3914,
	"./images/our_products_tmp.jpeg": 30169,
	"./images/spinner.svg": 33126,
	"./images/success-day.svg": 89501,
	"./images/success-training.svg": 72623,
	"./lang/de": 10601,
	"./lang/de.json": 10601,
	"./lang/en": 35725,
	"./lang/en.json": 35725
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50290;